import Home from './Home.data-manager-edit-os.vue'

export default {
  Home
}